import gql from "graphql-tag"

export default gql`
  fragment IngestionSourceFragment on IngestionSource {
    id
    name
    providerId
    destinationProviderId
    rootPath
    enabled
    autoImport
    scanIntervalSeconds
    stabilitySeconds
    extensions
    lastScanAt
    lastScanError
  }
`
